import HTTPCore from "../../http.core";

class SatHttpService extends HTTPCore {
  constructor() {
    super({});
  }
  getEnv() {
    return process.env.REACT_APP_ENDPOINT_SAT;
  }
  getToken() {
    let token = "";
    token = localStorage.getItem("at") || "";
    return `bearer ${token}`;
  }
  //==============================
  getEvaluationFormByParam(param) {
    let url = this.getEnv();
    let path = `/evaluation_form/by-param`
    let fullUrl = url + path
    return this.get(fullUrl, { params: param });
  }
  getEvaluatorHistoryByParam(param) {
    let url = this.getEnv();
    let path = `/evaluator_history/by-param`
    let fullUrl = url + path
    return this.get(fullUrl, { params: param });
  }
  getListEvaluationFormByParam(param) {
    let url = this.getEnv();
    let path = `/evaluation_form/list-by-param-for-evaluator`
    let fullUrl = url + path
    return this.get(fullUrl, { params: param });
  }
  saveEvaluationFormHistory(param) {
    let url = this.getEnv();
    let path = `/evaluator_history`
    let fullUrl = url + path
    return this.post(fullUrl, param);
  }
  updateEvaluatorProfile(param) {
    let url = this.getEnv();
    let path = `/evaluator`
    let fullUrl = url + path
    return this.put(fullUrl, param);
  }
  getEvaluatorById(param) {
    let url = this.getEnv();
    let path = `/evaluator/by-id/${param}`
    let fullUrl = url + path
    return this.get(fullUrl);
  }
  upsertEvaluatorByLineUserIdDto(param) {
    let url = this.getEnv();
    let path = `/evaluator/upsert-evaluator/by-line-user-id`
    let fullUrl = url + path
    return this.post(fullUrl, param);
  }
  saveEvaluatorServiceHistory(param) {
    let url = this.getEnv();
    let path = `/evaluator_service_history/by-check-time`
    let fullUrl = url + path
    return this.post(fullUrl, param);
  }
  //==============================
  getEvaluatorServiceHistoryLocationByParam(param) {
    let url = this.getEnv();
    let path = `/evaluator_service_history/location/by-param`
    let fullUrl = url + path
    return this.get(fullUrl, { params: param });
  }
  getEvaluationFormEvaluatorServiceHistoryByEvaluatorId(param) {
    let url = this.getEnv();
    let path = `/evaluator_service_history/evaluation-form/by-evaluator-id`
    let fullUrl = url + path
    return this.get(fullUrl, { params: param });
  }
  getDashboardFrequencyEvaluatorServiceHistoryByParam(param) {
    let url = this.getEnv();
    let path = `/evaluator_service_history/dashboard-evaluator-frequency/by-param`
    let fullUrl = url + path
    return this.get(fullUrl, { params: param });
  }
  //==============================
}

export {
  SatHttpService
};
